// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #0467a0 0%, #035a8a 50%, #ff0000 100%);
}

.App-header {
  background: rgba(255, 255, 255, 0.95);
  padding: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  min-height: auto;
  display: block;
  font-size: inherit;
  color: #333;
}

.header-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 20px;
}

.logo {
  flex-shrink: 0;
  margin-left: 20px;
  margin-top: 10px;
}

.logo-image {
  width: 100px;
  height: 100px;
  object-fit: contain;
  border-radius: 50%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.title-section {
  flex: 1 1;
  text-align: center;
  margin: 0 20px;
}

.title-section h1 {
  margin: 0;
  color: #333;
  font-size: 1.3rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  line-height: 1;
}

.title-section h2 {
  margin: 1px 0 0 0;
  color: #333;
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.3px;
  line-height: 1.2;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 15px;
  font-size: 1rem;
  color: #666;
}

.user-info span {
  font-weight: 500;
}

.logout-btn {
  background: #ff0000;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.logout-btn:hover {
  background: #cc0000;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(255, 0, 0, 0.3);
}

.App-header h1 {
  margin: 0 0 20px 0;
  color: #333;
  font-size: 2.5rem;
  font-weight: 700;
}

.nav-tabs {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 20px;
  padding-bottom: 15px;
  border-bottom: 2px solid #e9ecef;
}

.nav-tab {
  padding: 8px 16px;
  border: none;
  background: transparent;
  color: #666;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: auto;
  border-radius: 0;
  position: relative;
}

.nav-tab:hover {
  color: #0467a0;
  transform: translateY(-1px);
  font-weight: 600;
}

.nav-tab.active {
  color: #0467a0;
  font-weight: 700;
}

.nav-tab.active::after {
  content: '';
  position: absolute;
  bottom: -17px;
  left: 0;
  right: 0;
  height: 3px;
  background: #0467a0;
  border-radius: 2px;
}



.nav-tab.view-data-btn:hover {
  color: #0467a0;
}

.nav-tab.view-data-btn.active {
  color: #0467a0;
}

.nav-tab.view-data-btn.active::after {
  background: #0467a0;
}

.nav-tab.verify-data-btn:hover {
  color: #0467a0;
}

.nav-tab.verify-data-btn.active {
  color: #0467a0;
}

.nav-tab.verify-data-btn.active::after {
  background: #0467a0;
}



.nav-tab.form402-btn:hover {
  color: #0467a0;
}

.nav-tab.form402-btn.active {
  color: #0467a0;
}

.nav-tab.form402-btn.active::after {
  background: #0467a0;
}

.nav-tab.form403-btn:hover {
  color: #0467a0;
}

.nav-tab.form403-btn.active {
  color: #0467a0;
}

.nav-tab.form403-btn.active::after {
  background: #0467a0;
}

.nav-tab.settings-btn:hover {
  color: #0467a0;
}

.nav-tab.settings-btn.active {
  color: #0467a0;
}

.nav-tab.settings-btn.active::after {
  background: #0467a0;
}

.nav-tab.users-btn:hover {
  color: #0467a0;
}

.nav-tab.users-btn.active {
  color: #0467a0;
}

.nav-tab.users-btn.active::after {
  background: #0467a0;
}



@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.App-main {
  padding: 20px;
  max-width: 1400px;
  margin: 0 auto;
}

.view-data {
  background: white;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  margin-top: 20px;
}

.view-data h2 {
  color: #333;
  margin-bottom: 20px;
}

/* Responsive Design */
@media (max-width: 768px) {
  .header-top {
    flex-direction: column;
    text-align: center;
    gap: 15px;
  }
  
  .logo-image {
    width: 80px;
    height: 80px;
  }
  
  .title-section h1 {
    font-size: 1.1rem;
  }
  
  .title-section h2 {
    font-size: 0.6rem;
  }
  
  .user-info {
    flex-direction: column;
    gap: 10px;
  }
  
  .nav-tabs {
    flex-direction: column;
    align-items: center;
    gap: 10px;
  }
  
  .nav-tab {
    width: 100%;
    max-width: 200px;
    text-align: center;
  }
  
  .App-main {
    padding: 10px;
  }
}

@media (max-width: 480px) {
  .logo-image {
    width: 70px;
    height: 70px;
  }
  
  .title-section h1 {
    font-size: 0.95rem;
  }
  
  .title-section h2 {
    font-size: 0.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,0EAA0E;AAC5E;;AAEA;EACE,qCAAqC;EACrC,aAAa;EACb,yCAAyC;EACzC,2BAA2B;EAC3B,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,OAAO;EACP,QAAQ;EACR,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;;;AAIA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;;;AAIA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;;;AAIA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".App {\n  text-align: center;\n  min-height: 100vh;\n  background: linear-gradient(135deg, #0467a0 0%, #035a8a 50%, #ff0000 100%);\n}\n\n.App-header {\n  background: rgba(255, 255, 255, 0.95);\n  padding: 20px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  backdrop-filter: blur(10px);\n  min-height: auto;\n  display: block;\n  font-size: inherit;\n  color: #333;\n}\n\n.header-top {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  flex-wrap: wrap;\n  gap: 20px;\n}\n\n.logo {\n  flex-shrink: 0;\n  margin-left: 20px;\n  margin-top: 10px;\n}\n\n.logo-image {\n  width: 100px;\n  height: 100px;\n  object-fit: contain;\n  border-radius: 50%;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.title-section {\n  flex: 1;\n  text-align: center;\n  margin: 0 20px;\n}\n\n.title-section h1 {\n  margin: 0;\n  color: #333;\n  font-size: 1.3rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  line-height: 1;\n}\n\n.title-section h2 {\n  margin: 1px 0 0 0;\n  color: #333;\n  font-size: 0.7rem;\n  font-weight: 600;\n  text-transform: none;\n  letter-spacing: 0.3px;\n  line-height: 1.2;\n}\n\n.user-info {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  font-size: 1rem;\n  color: #666;\n}\n\n.user-info span {\n  font-weight: 500;\n}\n\n.logout-btn {\n  background: #ff0000;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 20px;\n  font-size: 0.9rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.logout-btn:hover {\n  background: #cc0000;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px rgba(255, 0, 0, 0.3);\n}\n\n.App-header h1 {\n  margin: 0 0 20px 0;\n  color: #333;\n  font-size: 2.5rem;\n  font-weight: 700;\n}\n\n.nav-tabs {\n  display: flex;\n  justify-content: center;\n  gap: 20px;\n  margin-top: 20px;\n  padding-bottom: 15px;\n  border-bottom: 2px solid #e9ecef;\n}\n\n.nav-tab {\n  padding: 8px 16px;\n  border: none;\n  background: transparent;\n  color: #666;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-width: auto;\n  border-radius: 0;\n  position: relative;\n}\n\n.nav-tab:hover {\n  color: #0467a0;\n  transform: translateY(-1px);\n  font-weight: 600;\n}\n\n.nav-tab.active {\n  color: #0467a0;\n  font-weight: 700;\n}\n\n.nav-tab.active::after {\n  content: '';\n  position: absolute;\n  bottom: -17px;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background: #0467a0;\n  border-radius: 2px;\n}\n\n\n\n.nav-tab.view-data-btn:hover {\n  color: #0467a0;\n}\n\n.nav-tab.view-data-btn.active {\n  color: #0467a0;\n}\n\n.nav-tab.view-data-btn.active::after {\n  background: #0467a0;\n}\n\n.nav-tab.verify-data-btn:hover {\n  color: #0467a0;\n}\n\n.nav-tab.verify-data-btn.active {\n  color: #0467a0;\n}\n\n.nav-tab.verify-data-btn.active::after {\n  background: #0467a0;\n}\n\n\n\n.nav-tab.form402-btn:hover {\n  color: #0467a0;\n}\n\n.nav-tab.form402-btn.active {\n  color: #0467a0;\n}\n\n.nav-tab.form402-btn.active::after {\n  background: #0467a0;\n}\n\n.nav-tab.form403-btn:hover {\n  color: #0467a0;\n}\n\n.nav-tab.form403-btn.active {\n  color: #0467a0;\n}\n\n.nav-tab.form403-btn.active::after {\n  background: #0467a0;\n}\n\n.nav-tab.settings-btn:hover {\n  color: #0467a0;\n}\n\n.nav-tab.settings-btn.active {\n  color: #0467a0;\n}\n\n.nav-tab.settings-btn.active::after {\n  background: #0467a0;\n}\n\n.nav-tab.users-btn:hover {\n  color: #0467a0;\n}\n\n.nav-tab.users-btn.active {\n  color: #0467a0;\n}\n\n.nav-tab.users-btn.active::after {\n  background: #0467a0;\n}\n\n\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.App-main {\n  padding: 20px;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.view-data {\n  background: white;\n  padding: 30px;\n  border-radius: 10px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  margin-top: 20px;\n}\n\n.view-data h2 {\n  color: #333;\n  margin-bottom: 20px;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .header-top {\n    flex-direction: column;\n    text-align: center;\n    gap: 15px;\n  }\n  \n  .logo-image {\n    width: 80px;\n    height: 80px;\n  }\n  \n  .title-section h1 {\n    font-size: 1.1rem;\n  }\n  \n  .title-section h2 {\n    font-size: 0.6rem;\n  }\n  \n  .user-info {\n    flex-direction: column;\n    gap: 10px;\n  }\n  \n  .nav-tabs {\n    flex-direction: column;\n    align-items: center;\n    gap: 10px;\n  }\n  \n  .nav-tab {\n    width: 100%;\n    max-width: 200px;\n    text-align: center;\n  }\n  \n  .App-main {\n    padding: 10px;\n  }\n}\n\n@media (max-width: 480px) {\n  .logo-image {\n    width: 70px;\n    height: 70px;\n  }\n  \n  .title-section h1 {\n    font-size: 0.95rem;\n  }\n  \n  .title-section h2 {\n    font-size: 0.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
